// extracted by mini-css-extract-plugin
module.exports = {"confettiWrapper":"Confetti_confettiWrapper__XQAEw"};